export enum Pages {
  AutomationAnalytics = 'automation-analytics',
  Contacts = 'contacts',
  ContactLists = 'contact-lists',
  AdminClients = 'admin-clients',
  Campaigns = 'campaigns',
  ImportHistory = 'import-history'
}
